import { IAssetData } from '../../helpers/data/assetData'

const getAsset = (miscAssets: IAssetData[]): IAssetData => {
	return miscAssets[Math.floor(miscAssets.length * Math.random())]
}

export default getAsset
